/* bh-duo.js: slides the Souvenir banner boxes in together when the section scrolls into view.
   Boxes are visible by default (no JS, reduced motion, old browsers); the hidden start state is
   only applied after this script has armed the section. */
(function () {
  var sections = document.querySelectorAll('[data-bh-duo]');
  if (!sections.length) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { threshold: 0.2 });

  sections.forEach(function (el) {
    if (el.classList.contains('is-armed')) return;
    el.classList.add('is-armed');
    io.observe(el);
  });
})();
